import { KTIcon } from "../../../../_metronic/helpers";

const AddListingModalHeader = ({
  getUser,
  user,
  setShowListingModal,
}) => {
  return (
    <div className="modal-header">
      {/* begin::Modal title */}
      <h2 className="fw-bolder">Add New Listing for {user?.first_name} {user?.last_name}</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary"
        data-kt-users-modal-action="close"
        onClick={() => {
          setShowListingModal(false);
        }}
        style={{ cursor: "pointer" }}
      >
        <KTIcon iconName="cross" className="fs-1" />
      </div>
      {/* end::Close */}
    </div>
  );
};

export { AddListingModalHeader };
